import React from "react";
import TranslationWrapper, {
  getTranslation,
} from "../../../../../components/TranslationWrapper/TranslationWrapper.tsx";

import Button from "../../../../../components/CustomButtons/Button";
import { Add } from "@mui/icons-material";

//Styles
import { withStyles } from "tss-react/mui";
import ButtonBarStyle from "./ButtonbarStyle";

function Buttonbar({ ...props }) {
  const { classes } = props;

  const buttons = [
    {
      color: "primary",
      label: getTranslation("vestigingen.form.customfields.buttonbar.label.text", "Text"),
      type: "text",
      checkoutField: false,
    },
    {
      color: "primary",
      label: getTranslation("vestigingen.form.customfields.buttonbar.label.email", "E-mail"),
      type: "email",
      checkoutField: false,
    },
    {
      color: "primary",
      label: getTranslation("vestigingen.form.customfields.buttonbar.label.select", "Select"),
      type: "select",
      checkoutField: false,
    },
    {
      color: "primary",
      label: getTranslation("vestigingen.form.customfields.buttonbar.label.coupon", "Coupon"),
      type: "coupon",
      checkoutField: true,
    },
    {
      color: "primary",
      label: (
        <TranslationWrapper tDefault={"Mobiel nr"} tKey={"vestigingen.form.customfields.buttonbar.label.mobielNr"} />
      ),
      type: "mobilenr",
      checkoutField: false,
    },
    {
      color: "primary",
      label: (
        <TranslationWrapper
          tDefault={"preOrderDate"}
          tKey={"vestigingen.form.customfields.buttonbar.label.preOrderDate"}
        />
      ),
      type: "selectpreorderingdate",
      checkoutField: true,
    },
    {
      color: "primary",
      label: (
        <TranslationWrapper
          tDefault={"preOrderTime"}
          tKey={"vestigingen.form.customfields.buttonbar.label.preOrderTime"}
        />
      ),
      type: "selectpreorderingtime",
      checkoutField: true,
    },
    {
      color: "primary",
      label: (
        <TranslationWrapper
          tDefault={"preOrderDateDefault"}
          tKey={"vestigingen.form.customfields.buttonbar.label.preOrderDateDefault"}
        />
      ),
      type: "selectpreorderingdatedefault",
      checkoutField: true,
    },
    {
      color: "primary",
      label: (
        <TranslationWrapper
          tDefault={"preOrderTimeDefault"}
          tKey={"vestigingen.form.customfields.buttonbar.label.preOrderTimeDefault"}
        />
      ),
      type: "selectpreorderingtimedefault",
      checkoutField: true,
    },
  ].map((value, key) => {
    return props.checkoutShowCheckoutFields === undefined ||
      props.checkoutShowCheckoutFields ||
      (!props.checkoutShowCheckoutFields && !value.checkoutField) ? (
      <Button
        className={classes.middleButton}
        color={value.color}
        disabled={props.disableAll}
        key={key}
        onClick={() => props.onClick(value.type)}
        size={"sm"}
      >
        {value.label}
      </Button>
    ) : null;
  });

  return (
    <div className={classes.buttonGroup}>
      <Button className={classes.firstButton + " " + classes.plusButton} disabled justIcon size={"sm"}>
        <Add />
      </Button>
      {buttons}
    </div>
  );
}

export default withStyles(Buttonbar, ButtonBarStyle);
